// 	*** VARIABLES ***

const navbar = $('.navbar');
const hero = $('.sagan-head');
const headerLogoContainer = $('#site-header-logo');
const headerLogoBigscreen = $('.site-header__logo img');
const headerLogoMobile = $('.site-header__logo-mobile img');
const headerLogoSize = "140px";
const pageContainer = $('#PageContainer');
var breakpoint = false;
let sticky = navbar.offset().top;
let w = calcWindowWidth();
let h = calcWindowHeight();







// 	*** DYNAMIC CONTENT FUNCTIONS ***

function calcWindowWidth(){
	return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

function calcWindowHeight(){
	return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

function calcHeroHeight(h){
	let h2 = window.innerHeight;
  hero.height(h2-navbar.height());
}

function calcNavHeight(){
	pageContainer.css("margin-top", navbar.height());
}

function stickIt() {
  // console.log($(window).scrollTop());

  if ($(window).scrollTop() >= sticky && !breakpoint) {
		console.log('stick');
    navbar.removeClass("navbar-absolute");
    navbar.addClass("navbar-sticky");
		logoFadeIn();
		breakpoint = true;
  }
	if ($(window).scrollTop() < sticky && breakpoint) {
		console.log('unstick');
    navbar.removeClass("navbar-sticky");
    navbar.addClass("navbar-absolute");
		logoFadeOut();
		breakpoint = false;
  }
};

$.fn.extend({
   qcss: function(css) {
      return $(this).queue(function(next) {
         $(this).css(css);
         next();
      });
   }
});

function logoFadeOut() {

	// console.log('logoFadeOut');
	// headerLogoContainer.css('display', 'none');
	// headerLogoBigscreen.css({"width": 0, "transition-duration": "0.2s"}).delay(200).qcss({"opacity": "0"});
	headerLogoBigscreen.css({"opacity": 0, "transition-duration": "0.4s"}).delay(400).qcss({"width": "0"});
};

function logoFadeIn() {

	// console.log('logoFadeIn');
	headerLogoBigscreen.css({"width": headerLogoSize, "transition-duration": "0.4s"}).delay(400).qcss({"opacity": "1"});
};






// 	*** SLIDESHOW ***

const slideshows = $('.s-slideshow-wrapper');

function slideshowSizeAdjustments(){
	console.log('size adjustment2');
	let imageWidth = $('#Sagan-Grid-Size-Reference').width();
	let imageGap = $('#Sagan-Gap-Size-Reference').width();
	let images = $('.s-slideshow-image-wrapper');
	let imageCount = images.length;
	let containerWrapper = $('.s-slideshow-wrapper');
	let container = $('.s-slideshow-wrapper-inner');
	let containerWidth = ((imageCount)*imageWidth + (imageCount+1)*imageGap);
	let initPosition = (containerWidth-w)/2;

	// $(container).width(containerWidth).css('left', initPosition);
	$(container).width(containerWidth);
	$(containerWrapper).scrollLeft(initPosition);
	$(images[0]).css('margin-left', imageGap);

	console.log(container.scrollLeft());
	for(i = 0; i < images.length; i++){
		let image = images[i];
		$(image).width(imageWidth).css('margin-right',imageGap+'px');
	};

	$(containerWrapper).scroll(function(){
		console.log(this.scrollLeft);
	})

};








// 	*** COLLECTION DISPLAY HELPER ***


function deleteMediaFromCollectionDescription(){
	$('.collection-description p:has(img, iframe)').css('display', 'none');
}

deleteMediaFromCollectionDescription();





// 	*** ARTICLE DISPLAY HELPER ***

let articleContentBlocks = $(".s-article-content p");

if (articleContentBlocks.length > 0){

	var articleContentBlocksWithImg = $(".s-article-content p:has(img)");
	var articleContentImages = $(".s-article-content img");
	var articleContentBlocksWithVideo = $(".s-article-content p:has(iframe)");
	var articleContentVideos = $(".s-article-content iframe");
	var articleContentBlocksWithText = $(".s-article-content p:not(:has(img, iframe))");

	function addClasses(){
		console.log("add classes");
		articleContentBlocksWithText.addClass('s-article-content-textblock');
		if (articleContentBlocksWithImg.length > 1){
			articleContentBlocksWithImg.addClass('s-article-content-imageblock');
		} else {
			articleContentBlocksWithImg.addClass('s-article-content-imageblock-singleimage');
		};
		articleContentBlocksWithVideo.addClass('s-article-content-videoblock');
	};

	function addDeviders(){
		console.log('Number of Blocks: ' + articleContentBlocks.length);
		for (i = 0; i < articleContentBlocks.length; i++) {
			let block = articleContentBlocks[i];
			let preIndex = (i-1);

			console.log(block.className);

			if ((i != 0) && ($(articleContentBlocks[(i-1)]).hasClass(block.className)) == false){
				// console.log("devider");
				$( "<div class='s-article-content-fullwidth-devider'></div>" ).insertBefore(block);
			}
		}
	};

	function addGridPositionElements(){
		$( "<div class='s-article-content-pre-textblock'></div>" ).insertBefore(articleContentBlocksWithText);
		$( "<div class='s-article-content-post-textblock'></div>" ).insertAfter(articleContentBlocksWithText);
		if (articleContentBlocksWithImg.length > 1){
			$( "<div class='s-article-content-pre-imageblock'></div>" ).insertBefore(articleContentBlocksWithImg);
			$( "<div class='s-article-content-post-imageblock'></div>" ).insertAfter(articleContentBlocksWithImg);
		} else {
			$( "<div class='s-article-content-pre-imageblock-singleimage'></div>" ).insertBefore(articleContentBlocksWithImg);
			$( "<div class='s-article-content-post-imageblock-singleimage'></div>" ).insertAfter(articleContentBlocksWithImg);
		};
		$( "<div class='s-article-content-pre-videoblock'></div>" ).insertBefore(articleContentBlocksWithVideo);
		$( "<div class='s-article-content-post-videoblock'></div>" ).insertAfter(articleContentBlocksWithVideo);
	};

	function buildWrapperAndAlttext(){
		for (i = 0; i < articleContentVideos.length; i++) {
			let video = articleContentVideos[i];
			function buildVideoWrapper(video){
				let newVideoWrapper = $('<div/>').addClass('s-video-wrapper');
				let next = $(video).next();
				$(video).before(newVideoWrapper);
				newVideoWrapper.append(video).append(next);
			}
			buildVideoWrapper(video);
		}
		for (i = 0; i < articleContentImages.length; i++) {
			let image = articleContentImages[i];
			let imageRatio = ($(image).width())/($(image).height());
			let altText = $(image).attr('alt');
			function buildImageWrapper(image, imageRatio){
				let newDivPortrait = $('<div/>').addClass('s-image-wrapper');
				let newDivLandscape = $('<div/>').addClass('s-image-wrapper-landscape');
				let next = $(image).next();
				$(image).before(newDivPortrait);
				newDivPortrait.append(image).append(next);
				// if (imageRatio <= 1){
				// 	$(image).before(newDivPortrait);
				// 	newDivPortrait.append(image).append(next);
				// } else {
				// 	$(image).before(newDivLandscape);
				// 	newDivLandscape.append(image).append(next);
				// }
			}
			buildImageWrapper(image, imageRatio);
			$( "<p class='s-article-img-alt'>" + altText + "</div>" ).insertAfter($(image).parent());
		}
	};

	console.log(articleContentBlocksWithText);

	addClasses();
	addDeviders();
	addGridPositionElements();
	buildWrapperAndAlttext();


} else {
	console.log("there is no Blog Article Content");
}





// 	*** EVENTS ***

window.addEventListener('load', function(){
	stickIt();
  console.log('load');
	let h = calcWindowHeight()
  calcHeroHeight(h);
	calcNavHeight();
	slideshowSizeAdjustments()
});

window.addEventListener('scroll', function(){
	// console.log('scroll');
  // console.log(sticky + ": " + $(window).scrollTop() + ", " + breakpoint);
  stickIt();
},false);

window.addEventListener('resize', function(){
  console.log('resize');
  var w = calcWindowWidth();
      h = calcWindowHeight();
  // calcHeroHeight(h);
	calcNavHeight();
	slideshowSizeAdjustments()
});




// 	*** OPEN LINKS IN NEW TABS ***

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}







// 	*** ACCORDEONS ***

	let siteAccordeonBlocks = $(".s-accordeon p");
	let siteAccordingContainer = $(".s-accordeon");

	if (siteAccordeonBlocks.length > 1){
		console.log('activate accordeon');
		$(siteAccordingContainer).html(siteAccordeonBlocks[0]);
		$("<div class='acc_panel' style='display:none'></div>").insertAfter(siteAccordeonBlocks[0]);
		$("<div class='acc_ctrl s-product-accordeon-btn'><p>More information …</p></div>").insertAfter(siteAccordeonBlocks[0]);
		$(".acc_panel:first").html(siteAccordeonBlocks.splice(1));


		// for (i = 1; i < siteAccordeonBlocks.length; i++) {
		//   $(siteAccordeonBlocks[i]).addClass('small-hide', 'big-hide');
		// };
		// $("<div class='acc_panel'></div>").insertAfter(siteAccordeonBlocks[0]);


		// $( "<div class="">More information</div>").insertAfter(siteAccordingBlocks[0]);
		// $("</div><div>test</div>").insertAfter(siteAccordeonBlocks[siteAccordeonBlocks.length - 1]);
		// $("<div class='acc_panel'>").insertAfter(siteAccordeonBlocks[0]);

		// $("<div class='acc_ctrl'><p>More information</p></div>").insertAfter(siteAccordeonBlocks[0]);
	};

	$(function() {
	  $('.acc_ctrl').on('click', function(e) {
	    e.preventDefault();
	    if ($(this).hasClass('active')) {
	    	// $(this).find(">:first-child").css({
	    	// 	'-webkit-transform' : 'rotate('+ 0 +'deg)',
	      //       '-moz-transform' : 'rotate('+ 0 +'deg)',
	      //       '-ms-transform' : 'rotate('+ 0 +'deg)',
	      //       'transform' : 'rotate('+ 0 +'deg)'});
	      	$(this).removeClass('active');
	      	$(this).next()
	      		.stop()
	      		.slideUp(250);

	    } else {
	    	// $(this).find(">:first-child").css({
	    	// 	'-webkit-transform' : 'rotate('+ 180 +'deg)',
	      //       '-moz-transform' : 'rotate('+ 180 +'deg)',
	      //       '-ms-transform' : 'rotate('+ 180 +'deg)',
	      //       'transform' : 'rotate('+ 180 +'deg)'});
	      	$(this).addClass('active');
	      	$(this).next()
	      		.stop()
	      		.slideDown(250);
	    }
	  });
	});
